import AppLayout from '../views/layouts/AppLayout'

export default [
  {
    path: '/checking',
    name: 'checking.index',
    component: () => import(/* webpackChunkName: "checking_index" */ '../views/checking/Index.vue'),
    meta: {
      layout: AppLayout,
      pageTitle: 'ระบบติดตามสถานะการออกเช็ค',
      bodyClass: 'app-page'
    }
  }
]
